<template>
  <div class="mx-auto my-2">
    <v-card class="mx-4" flat>
      <v-card-title>
        Health Professions
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            hide-details
            label="Search"
            single-line
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn
            v-if="canCreateHProfessions"
            class="teal white--text"
            depressed
            @click="addHealthProfession()"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          <span>Add Health Profession</span>
        </v-btn>
      </v-card-title>
      <v-data-table
          :headers="headers"
          :items="healthProfessions.rows"
          :loading="loading"
          :options.sync="options"
          :server-items-length="healthProfessions.count"
          class="elevation-1"
          loading-text="Loading... please wait"
      >
        <template v-slot:[`item.name`]="{ item }">
          <label for="item">{{ item.name ? item.name : "-" }}</label>
        </template>
        <template v-slot:[`item.code`]="{ item }">
          <label for="item">{{ item.code ? item.code : "-" }}</label>
        </template>
        <template v-if="canEditHProfessions" v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  class="mr-2"
                  style="color: teal"
                  @click="editHealthProfession(item)"
                  v-on="on"
              >mdi-circle-edit-outline
              </v-icon
              >
            </template>
            <span>Edit Health Profession</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.isActive`]="{ item }">
          <v-chip :color="getColor(item.isActive)" dark>
            {{ item.isActive == true ? "Active" : "Not Active" }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <v-dialog v-model="dialog" persistent width="50%">
        <v-card>
          <v-card-title
              class="headline font-weight-regular blue-grey white--text"
              primary-title
          >{{ title }}

            <v-spacer></v-spacer>

            <v-btn color="white" text @click="closeDialog()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title
          >
          <v-divider></v-divider>
          <HrdAddHealthProfession
              v-if="dialog"
              :healthProfession="healthProfession"
              @close="closeDialog()"
              @registerOrUpdateHealthProf="registerOrUpdateHealthProf"
          ></HrdAddHealthProfession>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import HrdAddHealthProfession from "./hrd-add-health-profession.vue";
import {LookupService} from "../../../common/api.service";
import {HealthProfessionService} from "./healthProfession.service";
import {getUser} from "@/utils/helper";

export default {
  components: {
    HrdAddHealthProfession,
  },
  data() {
    return {
      search: "",
      loading: false,
      headers: [
        {text: "Health Profession Name", value: "name"},
        {text: "Health Profession Code", value: "code"},
        {text: "Health Profession Status", value: "isActive"},
        {text: "Actions", value: "actions", sortable: false, align: "center"},
      ],
      healthProfessions: [],
      healthProfession: null,
      dialog: false,
      title: "",
      options: {
        page: 1,
        itemsPerPage: 10,
      },
    };
  },
  async beforeMount() {
    this.fetchHealthProfessions();
  },
  watch: {
    options: {
      handler() {
        this.fetchHealthProfessions();
      },
      deep: true,
    },
    search: function (val) {
      this.search = val;
      this.fetchHealthProfessions();
    },
  },
  computed: {
    canCreateHProfessions() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Health Professions" && permission.canCreate
      );
    },
    canEditHProfessions() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Health Professions" && permission.canUpdate
      );
    },
  },
  methods: {
    async fetchHealthProfessions() {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const res = await LookupService.getHealthProffesionsWP(
          page,
          itemsPerPage,
          this.search
      );
      if (res.status === 200) {
        this.loading = false;
        this.healthProfessions = res.data;
      } else {
        this.loading = false;
        this.$toast.error(
            "There was a problem fetching health professions, Please try Again!"
        );
      }
    },
    addHealthProfession() {
      this.healthProfession = null;
      this.dialog = true;
      this.title = "Add Health Profession";
    },
    editHealthProfession(item) {
      this.healthProfession = item;
      this.dialog = true;
      this.title = "Edit Health Profession";
    },
    closeDialog() {
      this.dialog = false;
      this.fetchHealthProfessions();
    },
    getColor(isActive) {
      if (isActive == false) return "red";
      else return "green";
    },
    async registerOrUpdateHealthProf(healthProfession) {
      this.loading = true;
      let res = null;

      if (healthProfession.editMode) {
        res = await HealthProfessionService.update(
            healthProfession.id,
            healthProfession
        );

        if (res.status === 201) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchHealthProfessions();
              this.loading = false;
              break;
            case 500:
              this.$toast.error(res.data.message);
              this.loading = false;
              break;
          }
        } else {
          this.$toast.error(
              "Unable to update health profession, please try again"
          );
          this.loading = false;
        }
      } else {
        res = await HealthProfessionService.create(healthProfession);

        if (res.status === 200) {
          switch (res.data.status) {
            case 200:
              this.$toast.success(res.data.message);
              this.fetchHealthProfessions();
              this.loading = false;

              break;
            case 500:
              this.$toast.error(res.data.message);
              this.loading = false;

              break;
          }
        } else {
          this.$toast.error(
              "Unable to create health profession, please try again"
          );
          this.loading = false;
        }
      }
      this.loading = false;
    },
  },
};
</script>
